// extracted by mini-css-extract-plugin
export default {"pathElem":"KNPZa6V8"};